import { useCurrentUser, useCurrentCompany } from 'javascripts/hooks';
import { ADMIN, MANAGER, hasRoleAccess } from 'helpers/roles';
import { useProjectCollaboration } from 'components/projects/collaboration/hooks';

type useChecklistAdminStatusParams = {
  projectNodeId: string;
  checklistCreatorId: string;
};

const useChecklistAdminStatus = ({
  projectNodeId,
  checklistCreatorId,
}: useChecklistAdminStatusParams) => {
  const user = useCurrentUser();
  const isAdmin = hasRoleAccess(user, [ADMIN, MANAGER]);

  const isCreator = user.node_id === checklistCreatorId;

  const { currentCompany } = useCurrentCompany();
  const { owningCollaborator, loading } =
    useProjectCollaboration(projectNodeId);
  const isCollaborator = currentCompany.node_id !== owningCollaborator.id;

  return {
    loading,
    // Includes the following privileges (create, edit, rearrange, export, delete)
    isChecklistAdmin: isCreator || (isAdmin && !isCollaborator),
    isTemplateAdmin: isAdmin && !isCollaborator,
  };
};

export default useChecklistAdminStatus;
